<template>
    <app-dialog :isUploadOrder="true" :title="$t('uploadOrder.title')" v-bind="$attrs" :value="value" @input="$emit('input', $event)" :width="getDialogWidth">
        <template v-slot:content>
            <div class="px-3 py-3 upload-order-text" data-cy="app-upload-order-text">
                <div class="upload-order-text-start">
                    {{ $t('uploadOrder.intro1') }}<br />
                    {{ $t('uploadOrder.intro2') }}
                </div>
                <div class="d-flex justify-cente btns-downloadr">
                    <div class="d-flex py-2 justify-center">
                        <v-btn text class="myprovet-btn-cancel xlsx" style="max-width: 300px !important" @click="downloadTemplate('xlsx')">{{ $t('uploadOrder.xlsx') }}</v-btn>
                    </div>
                    <div class="d-flex pl-8 py-2 justify-center">
                        <v-btn text class="myprovet-btn-cancel cvs" style="max-width: 300px !important" @click="downloadTemplate('csv')">{{ $t('uploadOrder.csv') }}</v-btn>
                    </div>
                </div>
                <div class="col-md-12 upload-order-text-end">
                    <span>{{ $t('uploadOrder.afterFill') }}</span><br /><br />
                    <span><strong>{{ $t('uploadOrder.clearsCart') }}</strong></span>
                </div>
                <!-- The native file input text ("Escolher ficheiro") follows the browser language, so it is hidden and replaced by a button -->
                <div class="d-flex align-center col-md-12">
                    <input type="file" id="file" class="d-none" ref="file" accept=".xlsx,.csv" v-on:change="onChangeFileUpload()" />
                    <v-btn small text outlined class="myprovet-btn-cancel" @click="$refs.file.click()">{{ $t('uploadOrder.chooseFile') }}</v-btn>
                    <span class="ml-3 font-size-md">{{ file ? file.name : $t('uploadOrder.noFileSelected') }}</span>
                </div>
            </div>
        </template>

        <template v-slot:buttons="{}">
            <v-btn text class="myprovet-btn-cancel" @click="$emit('input', false)">{{ $t('common.close') }}</v-btn>
            <v-btn text class="myprovet-btn-ok" @click="submitForm">{{ $t('uploadOrder.confirm') }}</v-btn>
        </template>
    </app-dialog>
</template>

<script>
import { axios } from '@/Services/Backend';
import { mapStores } from 'pinia';
import { useBranchStore } from '@/Stores/branch';
import { useNormalOrderStore } from '@/Stores/normalorder';

export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            documentValidated: false,
            file: null,
        };
    },

    computed: {
        ...mapStores(useBranchStore, useNormalOrderStore),

        getDialogWidth() {
            return this.getResponsiveDialogWidth('60vw', '35vw');
        },
    },

    methods: {
        downloadTemplate(docType) {
            const type = docType == 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-';
            const url = docType == 'csv' ? '/storage/assets/uploadEncomendaBase.csv' : '/storage/assets/uploadEncomendaBase.xlsx';
            axios({
                url: url,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                let fileURL = window.URL.createObjectURL(new Blob([response.data], { type: type }));
                let fileLink = document.createElement('a');

                fileLink.href = fileURL;

                fileLink.download = `Upload de Encomenda (Base).${docType}`;

                fileLink.click();
            });
        },

        onChangeFileUpload() {
            this.file = this.$refs.file.files[0];
            let extension = this.file.name?.split('.').pop();
            if (extension != 'xlsx' && extension != 'csv') return this.showError(this.$t('uploadOrder.invalidFile'));

            this.documentValidated = true;
        },

        submitForm() {
            let extension = this.file?.name?.split('.').pop();
            if (extension != 'xlsx' && extension != 'csv') return this.showError(this.$t('uploadOrder.invalidFile'));
            if (!this.documentValidated) return this.showError(this.$t('uploadOrder.noFile'));

            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('branch_id', this.branchStore.branch?.id);

            axios
                .post('/api/orders/upload-order', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then(({ data }) => {
                    this.normalOrderStore.clearCart(false); // Clear without refreshing remote carts
                    data.forEach((product) => {
                        this.addProductToCart(product);
                    });
                    this.showSuccess(this.$t('uploadOrder.success'));
                    this.normalOrderStore.sendCart(); // Refresh remote carts, now with the new data
                    this.$emit('input', false);
                })
                .catch((error) => {
                    if (error) this.showError(error.response.data.message);
                    console.log(error);
                });
        },

        addProductToCart(product) {
            this.normalOrderStore.addProduct(product);
            window.EventBus.$emit('product-quantity-change');
        },

        finish() {
            this.$emit('input', false);
        },
    },
};
</script>
